import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages, FormattedMessage } from 'react-intl';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles'
import style from './QuestionsPopUp.scss';
import Button from '../Button';
import CloseIcon from '../icons/CloseCircle';
import SiblingInformation from '../SiblingInformation/SiblingInformation';
import AddSibling from '../AddSibling/AddSibling';

const localMessages = defineMessages({
  yes: {
    id: 'questionsPopUp.yes',
    defaultMessage: 'Yes',
    description: 'Yes Radio Button',
  },
  no: {
    id: 'questionsPopUp.no',
    defaultMessage: 'No',
    description: 'No Radio Button',
  },
  additionalQuestionsText: {
    id: 'questionsPopUp.additionalQuestionsText',
    defaultMessage: 'Additional Questions',
    description: 'Additional Questions',
  },
  submitText: {
    id: 'questionsPopUp.submitText',
    defaultMessage: 'Submit',
    description: 'Submit',
  },
  cancelText: {
    id: 'questionsPopUp.cancelText',
    defaultMessage: 'Cancel',
    description: 'Cancel',
  }
})

class QuestionsPopUp extends React.Component {
  constructor(props) {
    super(props);
    this.answers = {};
    this.state = {
      error: '',
      error1: '',
      showSiblings: props.SiblingInfo && props.SiblingInfo.length > 0,
      siblings: [] && JSON.parse(JSON.stringify(props.SiblingInfo)),
      radio: {
        YES: props.SiblingInfo && props.SiblingInfo.length > 0,
        NO: props.showSiblingQuestion == 'NO' && props.SiblingInfo && props.SiblingInfo.length < 1,
      }
    };
  }

  addSibling = () => {
    if (this.state.siblings.length > 4) {
      this.setState({ ...this.state, error1: 'You can add maximum five siblings.' });
      return;
    }
    this.setState((prevState) => ({
      ...this.state,
      siblings: [...prevState.siblings, { fname:"", lname:"", dob: "", grade: "", osis: "", sid:  this.props.schoolId}],
    }));
  }
  removeSibling = (index) => {
    if (this.state.siblings.length <= 1) {
      this.setState(() => ({
        ...this.state,
        error1: '',
        siblings: this.state.siblings.filter((_, i) => i !== index),
        radio: {YES: false, NO: false}
      }));
    } else {
      this.setState(() => ({
        ...this.state,
        error1: '',
        siblings: this.state.siblings.filter((_, i) => i !== index)
      }));
    }
  }
  handleSiblingQuestionClick = (e) => {
    if (e.target.value == 'NO') {
      this.setState(() => ({
        ...this.state,
        showSiblings: false,
        siblings: [],
        radio: {YES: false, NO: true}
      }))
      return
    }
    if (this.state.siblings.length < 1) {
      this.setState(() => ({
        ...this.state,
        siblings: [{ fname:"", lname:"", dob: "", grade: "", osis: "", sid:  this.props.schoolId}],
        showSiblings: true,
        radio: {YES: true, NO: false}
      }))
    } else {
      this.setState(() => ({
        ...this.state,
        showSiblings: true,
        radio: {YES: true, NO: false}
      }))
    }
  }

  handleDOB = (idx, e) => {
    let sibling = this.state.siblings.filter((_, i) => i === idx)
    if (!sibling.length) {
      return
    }
    this.setState((prevState) => ({
      ...prevState,
      siblings: prevState.siblings.map((sibling, i) =>
        i === idx
          ? {
              ...sibling,
              dob: typeof e === "string" ? "" : e.format("MM-DD-YYYY"),
            }
          : sibling
      ),
      error1: typeof e === "string" ? "Date of birth is not valid." : "",
    }));
  }

  handleSiblingChange = (idx, key, value) => {
    let sibling = this.state.siblings.filter((_, i) => i === idx)
    if (!sibling.length) {
      return
    }
    this.setState((prevState) => ({
      ...prevState,
      siblings: prevState.siblings.map((sibling, id) => id === idx ? { ...sibling, [key]: value.trim() } : sibling
      ),
      error1: ''
    }));
  }
  handleInputChange = (e) => {
    const questionId = e.target.name;
    // clear error if there is one:
    if (this.state.error.length) {
      this.setState({ ...this.state, error: '' });
    }
    if (e.target.type === 'checkbox') {
      if (e.target.checked) {
        this.answers = { ...this.answers, [questionId]: [...this.answers[questionId], e.target.value] };
      } else {
        this.answers = {
          ...this.answers,
          [questionId]: this.answers[questionId].filter((value) => value !== e.target.value),
        };
      }
    } else {
      this.answers = { ...this.answers, [questionId]: [e.target.value] };
    }
  };

  isFutureDate = (dob) => {
    let today = new Date();
    today.setHours(23, 59, 59, 998);
    let dob_date = new Date(dob);
    return dob_date > today;
  }

  validateSibling = () => {
    let {siblings} = this.state;
    // case when sibling questions are not required. eg. HS, G&T
    if (siblings.length < 1) {
      return true;
    }
    for (let idx = 0; idx < siblings.length; idx++) {
      if (siblings[idx]['fname'].length < 1 || siblings[idx]['fname'].length > 30) {
        this.setState({ ...this.state, error1: 'First name is not valid.' });
        return false;
      }
      if (siblings[idx]['lname'].length < 1 || siblings[idx]['lname'].length > 30) {
        this.setState({ ...this.state, error1: 'Last name is not valid.' });
        return false;
      }
      if (siblings[idx]['grade'].length < 1) {
        this.setState({ ...this.state, error1: 'Grade is not valid.' });
        return false;
      }
      const regex = /^\d{2}-\d{2}-\d{4}$/;
      if (siblings[idx]['dob'].match(regex) === null) {
        this.setState({ ...this.state, error1: 'Date of birth is not valid.' });
        return false;
      }
      if (this.isFutureDate(siblings[idx]['dob'])) {
        this.setState({ ...this.state, error1: 'Date of birth can not be a future date.'});
        return false
      }
      if (siblings[idx]['osis'].length > 9) {
        this.setState({ ...this.state, error1: 'Osis ID is not valid.' });
        return false;
      }
    }
    return true;
  }

  handleFormSubmit = (e) => {
    e.preventDefault();
    if (this.props.showSiblingsQuestionsForm && !this.validateSibling()) {
      return
    }
    const keys = Object.keys(this.answers);
    const emptyAnswers = keys.filter(key => this.answers[key].length === 0);
    if (this.props.showSiblingsQuestionsForm && !this.state.radio.NO && !this.state.radio.YES) {
      this.setState({ ...this.state, error1: 'Please, answer all questions.' });
      return;
    }
    if (emptyAnswers.length) {
      this.setState({ ...this.state, error: 'Please, answer all questions.' });
      return;
    } else {
      let api_payload = {}
      api_payload = {"answers": this.answers, "siblings": this.state.siblings, "waitlist_id": this.props.waitListId}

      // console.log("##########", api_payload)
      this.props.saveAnswers(api_payload);
    }
  };

  handleCancelClick = (e) => {
    // persisting old state in case of cancel button click event.
    this.setState({...this.state, siblings: [] && JSON.parse(JSON.stringify(this.props.SiblingInfo))});
    this.props.handleCancelClick(e);
  }

  render() {
    const { additionalQuestions, schoolName, grades, showSiblingsQuestionsForm, endYear, user } = this.props;
    const { error, error1, showSiblings, siblings } = this.state;
    const unansweredQuestions = additionalQuestions ? additionalQuestions.filter(({ answers }) => answers === null) : [];
    return (
      <div className={style.modalContainer}>
        <div className={style.modalContent}>
          <h3><FormattedMessage {...localMessages.additionalQuestionsText} /></h3>
          <div className={style.timesContainer}>
            <button type="button" onClick={this.handleCancelClick} aria-label='Close'>
              <CloseIcon fill="#CCC" />
            </button>
          </div>
          <form onSubmit={this.handleFormSubmit} id="additional-questions">
            {additionalQuestions.map(
              ({ question_type, short_description, id: questionId, question, options, answers: previousAnswers }) => {
                const type = question_type.toLowerCase();
                if(!this.answers.hasOwnProperty(questionId)){
                  this.answers = { ...this.answers, [questionId]: [] };
                }
                if (type !== 'radio' && type !== 'checkbox' && previousAnswers && this.answers[questionId].length < 1) {
                  this.answers = { ...this.answers, [questionId]: [previousAnswers[0].text_answer] };
                }
                return (
                  <Fragment key={questionId}>
                    <h4 className={style.additionalQuestionsHeading} dangerouslySetInnerHTML={{ __html: `${short_description}` }} />
                    <label dangerouslySetInnerHTML={{ __html: `${question}` }} />
                    {options.length ? (
                      options.map(({ option, id: optionId }) => {
                        const checked = previousAnswers ? previousAnswers.findIndex(({ id }) => id === optionId) : -1;
                        if (checked !== -1) {
                          if (this.answers.hasOwnProperty(questionId) && !this.answers[questionId].includes (`${optionId}`)) {
                            this.answers = {
                              ...this.answers,
                              [questionId]: [...this.answers[questionId], `${optionId}`],
                            };
                          }
                        }
                        return (
                          <div key={optionId}>
                            <input
                              type={type}
                              id={optionId}
                              value={optionId}
                              name={questionId}
                              onChange={this.handleInputChange}
                              defaultChecked={checked !== -1}
                              // disabled={previousAnswers !== null}
                            />
                            <label htmlFor={optionId}>{option}</label>
                          </div>
                        );
                      })
                    ) : (
                      <input
                        type={type}
                        id={questionId}
                        name={questionId}
                        onChange={this.handleInputChange}
                        defaultValue={previousAnswers ? previousAnswers[0].text_answer : ''}
                        // disabled={previousAnswers !== null}
                      />
                    )}
                  </Fragment>
                );
              },
            )}
            {showSiblingsQuestionsForm ? (
              <Fragment >
                <SiblingInformation user={user} endYear={endYear} />
                <div id="sibling-question">
                  <input
                    type="radio"
                    id="sibling_question_yes"
                    name="sibling_question"
                    value="YES"
                    onChange={this.handleSiblingQuestionClick}
                    checked={this.state.radio.YES}
                  /><label htmlFor="sibling_question_yes"><FormattedMessage {...localMessages.yes} /></label>
                  <br />
                  <input
                    type="radio"
                    id="sibling_question_no"
                    name="sibling_question"
                    value="NO"
                    onChange={this.handleSiblingQuestionClick}
                    checked={this.state.radio.NO}
                  /><label htmlFor="sibling_question_no"><FormattedMessage {...localMessages.no} /></label>
                  <br />
                </div>
                {
                  showSiblings && siblings.map((sibling, idx)=> {
                    return (<AddSibling
                      key={idx}
                      idx={idx}
                      sibling={sibling}
                      grades={grades}
                      addSibling= {this.addSibling}
                      removeSibling= {this.removeSibling}
                      handleSiblingChange= {this.handleSiblingChange}
                      handleDOB={this.handleDOB}
                    />)
                  })
                }
                {error1.length ? (<p className={style.alert}>{error1}</p>) : null}
              </Fragment>
            ): null}
            {error.length ? (<p className={style.alert}>{error}</p>) : null}
            <Button type="submit" customClass={style.confirmationButton}><FormattedMessage {...localMessages.submitText} /></Button>
          </form>
          <Button type="button" customClass={style.confirmationButton} onClick={this.handleCancelClick}>
          <FormattedMessage {...localMessages.cancelText} />
          </Button>
        </div>
      </div>
    );
  }
}

QuestionsPopUp.propTypes = {
  acceptButtonText: PropTypes.string,
  schoolName: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  handleAcceptClick: PropTypes.func,
  handleCancelClick: PropTypes.func,
};

export default compose(
  injectIntl,
  withStyles(style),
)(QuestionsPopUp);